<template>
  <b-modal :id="id" dialog-class="modal-lg" @shown="shown" no-close-on-backdrop>
    <template slot="modal-header">
      <span>社團活動申請書審核</span>
      <b-button class="close" @click="cancel">
        <b-icon-x></b-icon-x>
      </b-button>
    </template>
    <div class="alert alert-warning" role="alert">
      1.請填寫活動企劃書「預期成效(教師勾選)」<br />
      2.退回時需填寫建議。<br />
    </div>
    <div role="tablist">
      <b-button class="mb-1" block v-b-toggle.accordion-1>基本資料</b-button>
      <b-collapse
        id="accordion-1"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-md-4 col-sm-12">
              <form-input
                v-model="vm.SYear"
                id="SYear"
                label="學年度"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
              <form-select v-model="vm.Semester" id="Semester" label="學期">
                <div is="option" value="u">上</div>
                <div is="option" value="d">下</div>
              </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
              <form-input
                v-model="vm.No"
                id="No"
                label="活動編號"
                type="text"
                disabled
              ></form-input>
            </div>
            <div class="col-12">
              <form-input
                v-model="vm.Name"
                id="Name"
                label="活動名稱"
                type="text"
                disabled
              ></form-input>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.Purpose"
                label="活動目的"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動時間
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-date-input
                v-model="vm.StartDay"
                id="StartDay"
                label="日期(起)"
                disabled
              ></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>時間(起)</label>
              <input
                v-model="vm.StartTime"
                class="form-control"
                type="time"
                disabled
              />
            </div>
            <div class="col-md-6 col-sm-12">
              <form-date-input
                v-model="vm.EndDay"
                id="EndDay"
                label="日期(訖)"
                disabled
              ></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>時間(訖)</label>
              <input
                v-model="vm.EndTime"
                class="form-control"
                type="time"
                disabled
              />
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動地點
          </div>
          <div class="card-body row">
            <div class="col-md-1 col-sm-12">
              <div class="form-group">
                <label>校內</label>
                <label class="form-control">
                  <input
                    type="checkbox"
                    v-model="vm.OnCampus"
                    true-value="true"
                    disabled
                  />
                </label>
              </div>
            </div>
            <div class="col-md-11 col-sm-12">
              <form-input
                v-model="vm.Place"
                id="Place"
                label="地點"
                type="text"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動人數
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Internals"
                id="Internals"
                label="本校人數"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Outsiders"
                id="Outsiders"
                label="外校人數"
                type="number"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            辦理社團
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-select
                v-model="vm.CommunityID"
                id="CommunityID"
                label="社團名稱"
                disabled
              >
                <div is="option" value="">請選擇</div>
                <div
                  is="option"
                  v-for="item in Communitys"
                  :key="item.key"
                  :value="item.key"
                >
                  {{ item.value }}
                </div>
              </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.StudentNo"
                id="StudentNo"
                label="負責人學號"
                type="text"
                student
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.StudentName"
                id="StudentName"
                label="負責人姓名"
                type="text"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-select v-model="vm.ClassID" label="負責人班級" disabled>
                <div
                  is="option"
                  v-for="o in classList"
                  :key="o.key"
                  :value="o.key"
                >
                  {{ o.value }}
                </div>
              </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Phone"
                id="Phone"
                label="負責人連絡電話"
                type="tel"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Email"
                id="Email"
                label="負責人聯絡信箱"
                type="email"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            社團自主檢核
          </div>
          <div class="card-body row">
            <div class="col-12">
              <label>
                <input
                  v-model="vm.SelfCheck1"
                  type="checkbox"
                  true-value="true"
                  disabled
                />活動辦理已注意智慧財產權相關規定，並響應智慧財產權的推動。 </label
              ><br />
              <label>
                <input
                  v-model="vm.SelfCheck2"
                  type="checkbox"
                  true-value="true"
                  disabled
                />活動設計未有違背善良風俗及願意嚴防脫序之行為。 </label
              ><br />
              <label>
                <input
                  v-model="vm.SelfCheck3"
                  type="checkbox"
                  true-value="true"
                  disabled
                />活動辦理中無酒精飲料。 </label
              ><br />
              <label>
                <input
                  v-model="vm.SelfCheck4"
                  type="checkbox"
                  true-value="true"
                  disabled
                />活動辦理中無明火設備。 </label
              ><br />
              <label>
                <input
                  v-model="vm.SelfCheck5"
                  type="checkbox"
                  true-value="true"
                  disabled
                />活動辦理中有明火設備(請與社團指導老師、課外組輔導人員、總務處業管人員及環安室共商安全措施)。 </label
              ><br />
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            經費來源
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.BudgetSource1"
                id="BudgetSource1"
                label="學員(幹部)"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.BudgetSource2"
                id="BudgetSource2"
                label="社費補助"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.BudgetSource3"
                id="BudgetSource3"
                label="學生會補助"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.BudgetSource4"
                id="BudgetSource4"
                label="其他補助"
                type="number"
                disabled
              ></form-input>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-2 @click="show2"
        >協辦社團</b-button
      >
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <table class="table">
          <thead>
            <tr>
              <th>項次</th>
              <th>性質</th>
              <th>社團</th>
            </tr>
          </thead>
          <tr
            v-for="(item, index) in unionTableData.value"
            :key="item.CommunityActivityUnionID"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.PropertyName }}</td>
            <th>{{ item.CommunityName }}</th>
          </tr>
        </table>

        <pagination
          v-model="pager"
          :rows="unionTableData.count"
          :rowperpage="10"
          @paging="load"
        ></pagination>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-3>活動企劃書</b-button>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <form-input
                v-model="vm.Name"
                id="Name"
                label="活動名稱"
                type="text"
                disabled
              ></form-input>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.Purpose"
                label="活動目的"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動時間
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-date-input
                v-model="vm.StartDay"
                id="StartDay"
                label="日期(起)"
                disabled
              ></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.StartTime"
                id="StartTime"
                label="時間(起)"
                type="time"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-date-input
                v-model="vm.EndDay"
                id="EndDay"
                label="日期(訖)"
                disabled
              ></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.EndTime"
                id="EndTime"
                label="時間(訖)"
                type="time"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動地點
          </div>
          <div class="card-body row">
            <div class="col-md-1 col-sm-12">
              <div class="form-group">
                <label>校內</label>
                <label class="form-control">
                  <input
                    type="checkbox"
                    v-model="vm.OnCampus"
                    true-value="true"
                    disabled
                  />
                </label>
              </div>
            </div>
            <div class="col-md-11 col-sm-12">
              <form-input
                v-model="vm.Place"
                id="Place"
                label="地點"
                type="text"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動人數
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Internals"
                id="Internals"
                label="本校人數"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Outsiders"
                id="Outsiders"
                label="外校人數"
                type="number"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            預期成效
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected1"
                  true-value="true"
                  disabled
                />
                溝通表達
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected2"
                  true-value="true"
                  disabled
                />
                持續學習
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected3"
                  true-value="true"
                  disabled
                />
                情緒管理
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected4"
                  true-value="true"
                  disabled
                />
                人際互動
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected5"
                  true-value="true"
                  disabled
                />
                團隊合作
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected6"
                  true-value="true"
                  disabled
                />
                問題解決
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected7"
                  true-value="true"
                  disabled
                />
                積極創新
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.SExpected8"
                  true-value="true"
                  disabled
                />
                紀律責任
              </label>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header text-danger">
            預期成效(教師勾選)
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected1"
                  true-value="true"
                />
                溝通表達
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected2"
                  true-value="true"
                />
                持續學習
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected3"
                  true-value="true"
                />
                情緒管理
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected4"
                  true-value="true"
                />
                人際互動
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected5"
                  true-value="true"
                />
                團隊合作
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected6"
                  true-value="true"
                />
                問題解決
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected7"
                  true-value="true"
                />
                積極創新
              </label>
            </div>
            <div class="col-md-3 col-sm-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.TExpected8"
                  true-value="true"
                />
                紀律責任
              </label>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動流程內容詳述(請按時間寫明人、事、物)
          </div>
          <div class="card-body row">
            <div class="col-12">
              <label class="form-control">
                <input
                  type="checkbox"
                  v-model="vm.BigScale"
                  true-value="true"
                  disabled
                />
                大規模活動(需上傳附件) <br />
              </label>
            </div>
            <div class="col-12">
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動申請書附件')"
                  >{{ f }}</a
                >
              </div>
            </div>
          </div>
          <div class="card-body row">
            <div class="col-12">
              <form-textarea
                v-model="vm.ActivityDesc"
                label="活動流程"
                disabled
              ></form-textarea>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.ActivityPeople"
                label="人員配當"
                disabled
              ></form-textarea>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.ActivityThing"
                label="所需器材"
                disabled
              ></form-textarea>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.Activity2Desc"
                label="活動流程(備案：雨天、臨時狀況)"
                disabled
              ></form-textarea>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.Activity2People"
                label="人員配當(備案：雨天、臨時狀況)"
                disabled
              ></form-textarea>
            </div>
            <div class="col-12">
              <form-textarea
                v-model="vm.Activity2Thing"
                label="所需器材(備案：雨天、臨時狀況)"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-4 @click="show4"
        >活動經費支出預算表</b-button
      >
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <table class="table">
          <thead>
            <tr>
              <th>項次</th>
              <th>支出項目</th>
              <th>用途說明</th>
              <th>單位</th>
              <th>單價</th>
              <th>數量</th>
              <th>總額</th>
              <th>備註</th>
            </tr>
          </thead>
          <tr
            v-for="(item, index) in budgetTableData.value"
            :key="item.CommunityActivityApplicationBudgetID"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.Name }}</td>
            <th>{{ item.Purpose }}</th>
            <th>{{ item.Unit }}</th>
            <th>{{ item.Price }}</th>
            <th>{{ item.Quantity }}</th>
            <th>{{ item.Total }}</th>
            <th>{{ item.Remark }}</th>
          </tr>
        </table>

        <div class="col-12 text-right font-weight-bold">
          <p>
            <u>總計：{{ budgetTotal }}</u>
          </p>
        </div>
        <pagination
          v-model="pager"
          :rows="budgetTableData.count"
          :rowperpage="10"
          @paging="load"
        ></pagination>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-5
        >活動報名 QR Code</b-button
      >
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body">
            <file-upload
              :url="
                '/api/communityactivityapplicationreview/File?id=' +
                  vm.CommunityActivityApplicationID +
                  '&no=' +
                  vm.No
              "
              @ok="ok5"
            ></file-upload>
            <div v-for="f in vm.QrCodeFiles" :key="f">
              <a :href="QrCodePath + f" target="_blank">{{ f }}</a>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>
    <template slot="modal-footer">
      <div class="col-12">
        <form-input
          v-model="vm.Suggestion"
          id="Suggestion"
          label="建議(通過後清除內容)"
        ></form-input>
      </div>
      <b-button variant="danger" @click="back" v-if="isEdit"
        ><b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise
        >退回</b-button
      >
      <b-button variant="primary" @click="pass" v-if="isEdit"
        ><b-icon-check2></b-icon-check2>通過</b-button
      >
      <b-button variant="secondary" @click="cancel"
        ><b-icon-x></b-icon-x>關閉</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { detail } from "@/views";
export default detail({
  name: "communityactivityapplicationDetail",
  api: "/api/communityactivityapplicationreview/",
  data: {
    classList: [],
    Communitys: [],
    budget: {
      CommunityActivityApplicationBudgetID: "",
      Name: "",
      Purpose: "",
      Unit: "",
      Price: 0,
      Quantity: 0,
      Total: 0,
      Remark: "",
      CommunityActivityApplicationID: "",
    },
    budgetTableData: { count: 0, value: [] },
    budgetTotal: 0,
    pager: {},
    vm: { Dir: "", Files: [], QrCodeDir: "", QrCodeFiles: [] },
    unionCommunitys: [],
    unionTableData: { count: 0, value: [] },
  },
  created: function() {
    this.$parameter.community().then((res) => {
      this.Communitys = res.data;
    });
    this.$parameter.class("", "", "", "", "").then((res) => {
      this.classList = res.data.Class;
    });
  },
  computed: {
    Path: function() {
      return this.$apiurl + this.vm.Dir;
    },
    QrCodePath: function() {
      return this.$apiurl + this.vm.QrCodeDir;
    },
    isEdit: function() {
      return this.vm.Approved == "W";
    },
  },
  methods: {
    load: function() {
      return this.$http({
        method: "get",
        url:
          "api/communityactivityapplicationbudget/Get?id=" +
          this.vm.CommunityActivityApplicationID,
        headers: this.pager,
      }).then((res) => {
        if (res.data) {
          this.budgetTableData.count = res.data.count;
          this.budgetTableData.value = res.data.value;
          this.budgetTotal = this.budgetTableData.value.reduce(
            (acc, item) => acc + item.Total,
            0
          );
        } else {
          this.budgetTableData.count = 0;
          this.budgetTableData.value = [];
        }
      });
    },
    reload: function() {
      this.pager.skip = 0;
      return this.load();
    },
    show4: function() {
      this.reload();
    },
    pass: function() {
      if (
        !(
          this.vm.TExpected1 ||
          this.vm.TExpected2 ||
          this.vm.TExpected3 ||
          this.vm.TExpected4 ||
          this.vm.TExpected5 ||
          this.vm.TExpected6 ||
          this.vm.TExpected7 ||
          this.vm.TExpected8
        )
      ) {
        this.$bvToast.toast("請勾選活動企劃書內的預期成效", {
          title: "",
          variant: "danger",
          solid: true,
        });
      } else {
        this.saveing = true;

        this.$http({
          method: "post",
          url: "api/communityactivityapplicationreview/Pass",
          data: this.vm,
        })
          .then(() =>
            this.$http({
              method: "put",
              url: "api/communityactivityreportreview/Put",
              data: this.vm,
            })
          )
          .then(() => {
            this.$bvToast.toast("審核通過", {
              title: "",
              variant: "success",
              solid: true,
            });
            this.$emit("reload");
            this.$bvModal.hide(this.id);
          })
          .finally(() => (this.saveing = false));
      }
    },
    back: function() {
      if (!this.vm.Suggestion) {
        this.$bvToast.toast("請填寫建議", {
          title: "",
          variant: "danger",
          solid: true,
        });
      } else {
        this.saveing = true;

        this.$http({
          method: "post",
          url: "api/communityactivityapplicationreview/Back",
          data: this.vm,
        })
          .then(() => {
            this.$bvToast.toast("已退回", {
              title: "",
              variant: "success",
              solid: true,
            });
            this.$emit("reload");
            this.$bvModal.hide(this.id);
          })
          .finally(() => (this.saveing = false));
      }
    },
    show2: function() {
      this.unionReload();
    },
    unionLoad: function() {
      return this.$http({
        method: "get",
        url:
          "api/communityactivityunion/Get?id=" +
          this.vm.CommunityActivityApplicationID,
        headers: this.pager,
      }).then((res) => {
        if (res.data) {
          this.unionTableData.count = res.data.count;
          this.unionTableData.value = res.data.value;
        } else {
          this.unionTableData.count = 0;
          this.unionTableData.value = [];
        }
      });
    },
    unionReload: function() {
      this.pager.skip = 0;
      return this.unionLoad();
    },
    ok5: function(e) {
      this.$bvToast.toast("上傳成功", {
        title: "",
        variant: "success",
        solid: true,
      });
      this.vm.QrCodeFiles = [];
      this.vm.QrCodeFiles.push(e.res.data);
    },
  },
});
</script>

<style></style>
